import { CanDeactivateFn } from '@angular/router';
import { OfferSitesComponent } from './offer-sites.component';

/**
 * Empêche de quitter Sites & tarifs avec des prix/activations non enregistrés sans confirmation
 * explicite -- voir `OfferSitesComponent#canDeactivate` (audit QA, même garde que le formulaire
 * d'offre).
 */
export const unsavedOfferSitesGuard: CanDeactivateFn<OfferSitesComponent> = (component) => component.canDeactivate();
